<template>
    <v-container fluid fill-height class="bg-cinza">
        <v-layout row align-center justify-center>
            <v-flex md4  class="text-center">
                  <v-card class="elevation-12">
                     <v-toolbar dark color="indigo">
                        <v-toolbar-title><v-icon>account_circle</v-icon> Cadastro de usuário</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-form 
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                        <v-card-text>
                            
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                    <v-text-field id="nome" prepend-icon="person" v-model="newUser.nome" name="nome" label="Nome completo" :rules="obrigatorioRules"
                                    type="text" required></v-text-field>
                                </v-flex>  
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field id="telefone" v-model="newUser.telefone" v-mask="'(##)####-####'" masked="true" :rules="obrigatorioRules" prepend-icon="phone" name="telefone" label="Telefone"
                                    type="text" required></v-text-field>
                                </v-flex>  
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field id="email" prepend-icon="mail" v-model="newUser.email" :rules="[rules.email]" name="email" label="Email"
                                    type="text" required></v-text-field>
                                </v-flex>  
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field id="senha" v-model="newUser.senha" prepend-icon="lock" name="senha" :rules="tamanhoRules" label="Senha"
                                    type="password" required></v-text-field>
                                </v-flex>  
                            </v-layout>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="criarConta" class="mb-2 mr-2" color="success"><v-icon>check</v-icon> Cadastrar</v-btn>
                        </v-card-actions>

                        </v-card-text>
                    </v-form>        
                  </v-card>
            </v-flex>
        </v-layout>
    </v-container>          
     
</template>

<script>
    export default {
        name: 'Cadastro',
        data() {
            return {
                valid: true,
                newUser:{
                    nome: '',
                    telefone: '',
                    email: '',
                    senha: ''
                },
                email: '',
                rules: {
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'E-mail inválido.'
                    }
                },
                obrigatorioRules: [
                    v => !!v || 'Este campo é obrigatório',
                    v => v.length <= 60 || 'Máximo 60 caracteres'
                ],
                tamanhoRules : [
                    v => !!v || 'Este campo é obrigatório',
                    v => v.length <= 8 || 'Máximo 8 caracteres'
                ]
            }
        },
        computed:{
            retorno: function () {
                return this.$store.getters.getRetorno
            }
        },
        methods: {
            criarConta() {
                let self = this
                self.newUser.telefone = self.newUser.telefone.replace("(","").replace(")","").replace("-","")
                this.$store.dispatch('signUserUp', this.newUser)
            }
        },
        watch:{
            retorno: function () {
                if(this.retorno){
                    this.$router.push({
                        name:'Signin'
                    })
                }
            }
        }
    }
</script>

<style scoped>

.bg-cinza{
    background:#EEEEEE
}

</style>
